module.exports = __webpack_public_path__ + "static/img/log.7798bf59.svg";